import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../../i18n/util";
import { applicationStore } from "../../../stores/ApplicationStore";
import { generalStore } from "../../../stores/GeneralStore";
import { useMobileMediaQuery } from "../../hooks/useMobileMediaQuery";
import { LoadingBar } from "../../ui/LoadingBar";
import { SideBar } from "../../ui/SideBar";
import { TopBar } from "../../ui/TopBar";
import { ApplicationRouter } from "../router/ApplicationRouter";
import { ApplicationRoutes } from "../router/ApplicationRoutes";

export const ApplicationContainerSite = observer(() => {
    const isMobile = useMobileMediaQuery();

    window.onbeforeunload = function () {
        return t("page.leave");
    };

    return (
        <>
            {!generalStore.hideNavigation && <TopBar />}
            <div style={{ display: "flex", flexGrow: 1 }}>
                {!isMobile && !generalStore.hideNavigation && (
                    <SideBar
                        elements={[
                            {
                                name: "screen.sidebar.personalData",
                                isEnabled: true,
                                url: ApplicationRoutes.PERSONAL_DATA,
                                alreadyFilled: applicationStore.isStepFinished["personalData"]
                            },
                            {
                                name: "screen.sidebar.details",
                                isEnabled: applicationStore.isStepFinished["personalData"],
                                url: ApplicationRoutes.DETAILS,
                                alreadyFilled: applicationStore.isStepFinished["details"]
                            },
                            {
                                name: "screen.sidebar.dataUpload",
                                isEnabled: applicationStore.isStepFinished["details"],
                                url: ApplicationRoutes.DATA_UPLOAD,
                                alreadyFilled: applicationStore.isStepFinished["dataUpload"]
                            },
                            {
                                name: "screen.sidebar.motivation",
                                isEnabled: applicationStore.isStepFinished["dataUpload"],
                                url: ApplicationRoutes.MOTIVATION,
                                alreadyFilled: applicationStore.isStepFinished["motivation"]
                            },
                            {
                                name: "screen.sidebar.verify",
                                isEnabled: applicationStore.isStepFinished["motivation"],
                                url: ApplicationRoutes.VERIFICATION,
                                alreadyFilled: applicationStore.isStepFinished["verification"]
                            }
                        ]}
                    />
                )}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%"
                    }}
                >
                    {isMobile && !generalStore.hideNavigation && (
                        <LoadingBar
                            elements={[
                                ApplicationRoutes.PERSONAL_DATA,
                                ApplicationRoutes.DETAILS,
                                ApplicationRoutes.DATA_UPLOAD,
                                ApplicationRoutes.MOTIVATION,
                                ApplicationRoutes.VERIFICATION
                            ]}
                        />
                    )}
                    <ApplicationRouter />
                </div>
            </div>
        </>
    );
});
